import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './TutorChat.module.css';
import type { TutorSource } from './types';

const isHttp = (u?: string) => !!u && /^https?:\/\//i.test(u);

/** Renders nothing unless the message actually carries sources. */
const SourceChips: React.FC<{ sources?: TutorSource[] }> = ({ sources }) => {
  const { t } = useTranslation();
  if (!sources || sources.length === 0) return null;
  return (
    <div className={styles.sources}>
      <span className={styles.sourcesLabel} id="tutor-sources-label">
        {t('tutor.sources')}
      </span>
      <ul className={styles.sourceList} aria-labelledby="tutor-sources-label">
        {sources.map((s, i) => (
          <li key={s.id ?? `${s.title}-${i}`}>
            {isHttp(s.url) ? (
              <a
                className={styles.sourceChip}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className={styles.sourceIndex} aria-hidden>{i + 1}</span>
                {s.title}
              </a>
            ) : (
              <span className={styles.sourceChip}>
                <span className={styles.sourceIndex} aria-hidden>{i + 1}</span>
                {s.title}
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SourceChips;
